import { useEffect, useRef } from 'react';
import { sendOrvestoStatistics, trackViewEvent } from 'app/utils/statistics/clientStatistics';
import { UniversalStatistics } from '../../utils/statistics/universalStatistics';

type Props = {
    statisticsObject: UniversalStatistics;
};

const SendStatistics = ({ statisticsObject }: Props): null => {
    const hasBeenCalled = useRef(false);

    useEffect(() => {
        if (hasBeenCalled.current) return;

        if (statisticsObject && typeof window !== 'undefined') {
            statisticsObject.orvestoData && sendOrvestoStatistics(statisticsObject.orvestoData);
            statisticsObject.dataLake && trackViewEvent(statisticsObject.dataLake);
            hasBeenCalled.current = true;
        }
    }, [statisticsObject]);

    return null;
};

export default SendStatistics;
